import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useAppContext from "../../utils/Reducers";
import moment from "moment";
import { useAxiosWithAuthorization } from "../../utils/api";
import { useInterval } from "../../utils/validators";
import ButtonBar from "../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import {
  setStorageItem,
  getStorageItem,
} from "../../hooks/Storage/useLocalStorage";
import { ModalConfirm } from "../../components/Confirm";
import { saveGridCheckData } from "../../utils/validators";
import { columnLayout } from "./columnLayout";
import { ModalDepartureImagePop } from "../Popup/DepartureImagePop";
import { ModalIncomeCallPop } from "../Popup/IncomeCallPop";
import { ModalArriveCallPop } from "../Popup/ArriveCallPop";

import { defaultGridProps } from "../../components/AuiGrid/gridLayout";
import { useId } from "react-id-generator";
import useAuiGridMethods from "../../hooks/AuiGrid/useAuiGridMethods";

import { getCookie } from "../../utils/validators";
import { ModalNoticePop } from "../Popup/NoticePop";

//전송버튼을 클릭했을경우 함수가 외부에서 호출하여 primaryParameters 아무값도 들어가 있지 않음
//그래서 플래그를 두어 sendCnt값이 변경되면 useEffect에서 검색버튼의 함수를 실행시킴
var sendCnt = 0;
let auiGrid;
const MainPage = (props) => {
  var footerLayout = [
    {
      labelText: "합계",
      positionField: "#base",
    },
    {
      dataField: "plantNm",
      positionField: "plantNm",
      operation: "COUNT",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "inWeight",
      positionField: "inWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outWeight",
      positionField: "outWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "realWeight",
      positionField: "realWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outageWeight",
      positionField: "outageWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
  ];

  const [masterGrid] = useId(1, "aui-grid-");

  auiGrid = useAuiGridMethods(masterGrid);
  const [research, setResearch] = useState(0);

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  const [searchParameters, setSearchParameters] = useState({
    schPlantCd: userInfo.defaultPlantNo,
    schSearch: "",
    schTransStatusCd: "",
    schOdrType: "",
    schSwghtDt: moment().format("YYYY-MM-DD"),
    schEwghtDt: moment().format("YYYY-MM-DD"),
  });

  const initItem = {
    realWeight: "",
    statusD: "",
    statusI: "",
    statusS: "",
    statusT: "",
    statusTotal: "",
    statusW: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  const SEARCH_WAITVEHICLELIST_URL =
    "/domesticscrap/inspectionwait/searchWaitVehicleList.do";

  const SAVE_INSPECTION_REAMARK_URL =
    "/domesticscrap/inspectionwait/saveInspectionRemark.do";

  //배차정보 저장 URL
  const CHANGE_TRANSO_STATUS_URL =
    "/domesticscrap/inspectionwait/changeTransStatus.do";

  //하차지지역 변경 URL
  const CHANGE_UNLOADAREA_URL =
    "/domesticscrap/inspectionwait/changeUnloadArea.do";

  //배차정보 저장 URL
  //const MESSAGE_TRANSORDER_URL = "http://tms.idaehan.com:8080/message/sendTransCallInMessage.do";
  const MESSAGE_TRANSORDER_URL =
    "https://tms.idaehan.com:8443/message/sendTransCallInMessage.do";

  //배차취소 URL
  const MESSAGE_CALLCANCEL_URL =
    "https://tms.idaehan.com:8443/message/sendTransCallCancelMessage.do";

  //하차지변경 카카오톡 URL
  const MESSAGE_UNLOAD_URL =
    "https://tms.idaehan.com:8443/message/sendTransUnloadMessage.do";

  //const MESSAGE_UNLOAD_URL = "http://localhost:7080/message/sendTransUnloadMessage.do";

  //하차지변경 카카오톡 URL
  const MESSAGE_ARRIVE_URL =
    "https://tms.idaehan.com:8443/message/sendTransArriveMessage.do";

  //const MESSAGE_ARRIVE_URL = "http://localhost:7080/message/sendTransArriveMessage.do";

  //오늘 하루 통합 운송량 검색 URL
  const SERARCH_TRANSTOTALCOUNT_URL =
    "/domesticscrap/inspectionwait/searchTransTotalCount.do";

  //자재구매배차정보 저장 URL
  const SAVE_PURCHASE_URL = "/purchase/purchaseorder/savePurchaseOrder.do";

  //공지사항 검색 URL
  const SERARCH_NOTICEPOPUP_URL = "/common/board/searchNoticePopupList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_WAITVEHICLELIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    if (research !== 0) {
      handleMasterSearch();
    }
  }, [research]);

  const handleMasterSearch = async () => {
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_WAITVEHICLELIST_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);
    auiGrid.removeAjaxLoader();
    await searchTransTotalCount();
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    auiGrid.create(columnLayout(onIncomeButtonClick, popDepartureImage), {
      ...defaultGridProps,
      editable: true,
      showFooter: true,
      footerPosition: "top",
    });

    auiGrid.setFooter(footerLayout);

    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
    await handleMasterSearch();
    //공지사항 팝업 띄우기
    searchNoticePopopList();
  }, []);

  const searchNoticePopopList = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_NOTICEPOPUP_URL,
    });
    //console.log(data);
    if (data.length > 0) {
      data.forEach((item) => {
        var cookie = getCookie(item.boardId);
        if (cookie !== "end") {
          ModalNoticePop({ boardId: item.boardId, type: "ticket" });
        }
      });
    }
  };

  useInterval(() => {
    searchTransTotalCount();
  }, 60000);
  const searchTransTotalCount = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_TRANSTOTALCOUNT_URL,
      params: searchParameters,
    });

    setFieldValues(data[0]);
  };

  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      let validator = [];

      var items = auiGrid.getGridData();

      const addItems = auiGrid.getAddedRowItems();
      const editItems = auiGrid.getEditedRowItems();
      const removeItems = auiGrid.getRemovedItems();
      let param = saveGridCheckData(addItems, editItems, removeItems);

      if (param.length > 0) {
        //console.log(param[0]);

        const {
          data: { data },
        } = await fetchData({
          url: SAVE_INSPECTION_REAMARK_URL,
          data: param,
          method: "POST",
        });
        handleMasterSearch();
      } else {
        ModalConfirm({
          title: "필수항목체크",
          description: "저장할 항목이 없습니다. ",
          type: "alert",
        });
      }
    }
  };

  //팝업 데이터 가져오기
  const onSelectPlant = useCallback(async (values) => {
    const items = auiGrid.getSelectedItems()[0];

    //console.log(values);
    //console.log(items);

    const {
      data: { statusCode },
    } = await axios({
      method: "POST",
      url: MESSAGE_TRANSORDER_URL,
      data: {
        tmsOdrNo: items.item.tmsOdrNo,
        systemCd : items.item.systemCd,
        vhclNo: items.item.vhclNo,
        drivTel: items.item.drivTel,
        transStatusCd: "G",
      },
    }).catch(function (error) {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error(
          "카카오톡 전송 오류 : " + error.response.data.error.message
        );
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });

    if (statusCode === "200") {
      const {
        data: { data },
      } = await fetchData({
        url: CHANGE_TRANSO_STATUS_URL,
        data: {
          systemCd: items.item.systemCd,
          scrapAreaCd: values.scrapAreaCd,
          tmsOdrNo: items.item.tmsOdrNo,
          transStatusCd: "G",
        },
        method: "POST",
      });

      sendCnt = sendCnt + 1;
      //console.log(sendCnt);
      setResearch(sendCnt);
    } else {
      ModalConfirm({
        title: "입차호출 에러",
        description:
          "입차호출 에러로 다시 입차호출버튼을 클릭해주시기 바랍니다.  ",
        type: "alert",
      });
    }
  });

  const handleMasterExcel = useCallback(() => {
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      //exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  //메시지 전송을 하고 나서 배송상태값을 입차호출 T 로 변경
  const onIncomeButtonClick = useCallback(async (event) => {
    if (event.item.transStatusCd === "A") {
      if (event.item.tmsOdrNo !== "") {
        if (
          await ModalConfirm({
            title: "입차호출",
            description: event.item.drivTel + "님에게 입차호출 하겠습니까?",
          })
        ) {
          //console.log(event.item.plantCd);
          onIncomeCallIn(event.item.plantCd);
        }
      }
    } else if (event.item.transStatusCd === "G") {
      if (event.item.tmsOdrNo !== "") {
        if (
          await ModalConfirm({
            title: "입차취소",
            description:
              event.item.vhclNo + "차량의 입차호출을 취소하겠습니까?",
          })
        ) {
          const {
            data: { statusCode },
          } = await axios({
            method: "POST",
            url: MESSAGE_CALLCANCEL_URL,
            data: {
              tmsOdrNo: event.item.tmsOdrNo,
              systemCd: event.item.systemCd,
              vhclNo: event.item.vhclNo,
              drivTel: event.item.drivTel,
              transStatusCd: "B",
            },
          }).catch(function (error) {
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              //console.log(error.response.data);
              //console.log(error.response.status);
              //console.log(error.response.headers);
              toast.error(
                "카카오톡 전송 오류 : " + error.response.data.error.message
              );
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              //console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              //console.log("Error", error.message);
            }
            //console.log(error.config);
          });

          if (statusCode === "200") {
            const {
              data: { data },
            } = await fetchData({
              url: CHANGE_TRANSO_STATUS_URL,
              data: {
                systemCd: event.item.systemCd,
                scrapAreaCd: "",
                tmsOdrNo: event.item.tmsOdrNo,
                transStatusCd: "A",
              },
              method: "POST",
            });

            sendCnt = sendCnt + 1;
            //console.log(sendCnt);
            setResearch(sendCnt);
          }
        }
      }
    } else if (
      event.item.transStatusCd === "D" ||
      event.item.transStatusCd === "T"
    ) {
      if (event.item.tmsOdrNo !== "") {
        if (
          await ModalConfirm({
            title: "도착지변경",
            description:
              event.item.vhclNo +
              "차량의 도착지변경 카카오톡을 전송하시겠습니까?",
          })
        ) {
          //console.log(event.item.plantCd);
          onArriveCallIn(event.item.plantCd);
        }
      }
    }
  });

  const popDepartureImage = (event) => {
    //console.log(event.item);
    ModalDepartureImagePop({ tmsOdrNo: event.item.tmsOdrNo, type: "image" });
  };

  const onIncomeCallIn = (schPlantCd) => {
    ModalIncomeCallPop({
      title: "입차호출",
      schPlantCd: schPlantCd,
      onSelectPlant: onSelectPlant,
    });
  };

  const onArriveCallIn = (schPlantCd) => {
    ModalArriveCallPop({
      title: "도착지변경",
      schPlantCd: schPlantCd,
      onArriveCall: onArriveCall,
    });
  };

  //팝업 데이터 가져오기
  const onArriveCall = useCallback(async (values) => {
    const items = auiGrid.getSelectedItems()[0];
    console.log(values);

    const {
      data: { statusCode },
    } = await axios({
      method: "POST",
      url: MESSAGE_ARRIVE_URL,
      data: {
        systemCd: items.item.systemCd,
        tmsOdrNo: items.item.tmsOdrNo,
        vhclNo: items.item.vhclNo,
        drivTel: items.item.drivTel,
        unloadNm: values.scrapAreaNm,
      },
    }).catch(function (error) {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error(
          "카카오톡 전송 오류 : " + error.response.data.error.message
        );
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });
    if (statusCode === "200") {
      const {
        data: { data },
      } = await fetchData({
        url: CHANGE_UNLOADAREA_URL,
        data: {
          scrapAreaCd: values.scrapAreaCd,
          tmsOdrNo: items.item.tmsOdrNo,
        },
        method: "POST",
      });

      sendCnt = sendCnt + 1;
      //console.log(sendCnt);
      setResearch(sendCnt);
    }
  });

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = columnLayout(onIncomeButtonClick, popDepartureImage);
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });

  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    //console.log(items);
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  window.onresize = function () {
    // 크기가 변경되었을 때 AUIGrid.resize() 함수 호출
    if (typeof auiGrid !== "undefined") {
      auiGrid.resize();
    }
  };

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterSave={handleMasterSave}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />

      <table className="t_garo">
        <tr>
          <td> 운송차량 전체({fieldValues.statusTotal}대)</td>
          <td>1. 입고차량({fieldValues.statusS}대)</td>
          <td>2. 입고중량({fieldValues.realWeight}kg)</td>
          <td>3. 검수대기({fieldValues.statusW}대)</td>
          <td>4. 출차대기({fieldValues.statusI}대)</td>
          <td>5. 운송중({fieldValues.statusD}대)</td>
          <td>6. 운송대기({fieldValues.statusT}대)</td>
        </tr>
      </table>

      <div style={{ width: "100%", height: "100%" }}>
        <div id={masterGrid} style={{ width: "100%", height: 600 }} />
      </div>
    </>
  );
};

export default MainPage;
